<template>
    <div class="echarts-container-next" ref="chart"></div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  
  export default {
    props: ['initial'],
    mounted() {
      console.log("props mount",this.initial);
      this.initChart();
    },
    watch: {
      data: {
        immediate: true, // Trigger the watch immediately on mount
        handler(newData) {
          this.initChart(newData);
        },
      },
    },
    methods: {
      initChart() {
        console.log("props inner function",this.initial);
  
        let pharmacyNames = this.initial.map((pharmacy) => pharmacy.name);
        let totalAmount = this.initial.map((pharmacy) => pharmacy.total.totalAmount);
        let totalGst = this.initial.map((pharmacy) => pharmacy.total.totalGst);
        let totalTravelCompensation = this.initial.map(
          (pharmacy) => pharmacy.total.totalTravelCompensation
        );
        let totalSuperAmount = this.initial.map(
          (pharmacy) => pharmacy.total.totalSuperAmount
        );
        const option = {
          title: {
            text: 'Total Earned Bar Chart',
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
            valueFormatter: (value) => value,
          },
          xAxis: {
            type: 'category',
            data: pharmacyNames,
            axisLabel: {
              show: false, // Hide the x-axis label
              // You can add other axisLabel properties here if needed
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              name: 'Net Amount',
              data: totalAmount,
              type: 'bar',
              stack: 'stacked',
            },
            {
              name: 'Total GST',
              data: totalGst,
              type: 'bar',
              stack: 'stacked',
            },
            {
              name: 'Total Travel Compensation',
              data: totalTravelCompensation,
              type: 'bar',
              stack: 'stacked',
            },
            {
              name: 'Total Super Amount',
              data: totalSuperAmount,
              type: 'bar',
              stack: 'stacked',
            },
            // Add more series as needed
          ],
        };
  
        const chart = echarts.init(this.$refs.chart);
        chart.setOption(option);
      },
    },
  };
  </script>
  
  <style>
/* Style the container to take the full width on larger screens */
.echarts-container-next {
  width: 100%;
  height: 400px;
}

/* Apply different styles for smaller screens using media queries */
@media screen and (max-width: 767px) {
  /* For screens with width up to 767px (typically mobile devices) */
  .responsive-overflow {
    /* Add your responsive styling here */
    /* For example, you can set the width to 100% to make it full width */
    width: 100%;
    /* You can also add other styles as needed for mobile layout */
  }
}
</style>





